import * as React from "react";
import Props from "./index.d";
import GridBase from "../gridBase";

interface GFCFieldSet_Horizontal extends Props {
  children: React.ReactNode;
}

const GridContainerItem: React.FC<GFCFieldSet_Horizontal> = (props) => {
  return (
    <GridBase container item {...props}>
      {props.children}
    </GridBase>
  );
};
export default GridContainerItem;
